import { render, staticRenderFns } from "./DepositUnitInfo.vue?vue&type=template&id=45d80c23"
import script from "./DepositUnitInfo.vue?vue&type=script&lang=js"
export * from "./DepositUnitInfo.vue?vue&type=script&lang=js"
import style0 from "./DepositUnitInfo.vue?vue&type=style&index=0&id=45d80c23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports